import Intercom from "@intercom/messenger-js-sdk";
import { useGetCurrentUserQuery } from "@nerdjs/account-kit";
import moment from "moment";
import { useEffect } from "react";
import { useCurrentUser } from "../../redux/user/userHook";

/**
 *
 * @returns {ReactElement} IntercomConfig page
 */
export function IntercomConfig() {
  const { me } = useCurrentUser();

  useEffect(() => {
    if (me?.uuid) {
      const config = {
        app_id: "arj556zn",
        user_id: me.uuid, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
        name: `${me.firstName} ${me.lastName}`, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
        email: me.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
        created_at: moment(me.createdAt).unix(), // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
        company: "Mobile App",
        hide_default_launcher: true,
      };
      Intercom(config);
    }
  }, [me]);

  return <></>;
}
